module.exports = __webpack_public_path__ + "img/ups-cod-alternate-old.8751ac5b.png";